const notificationCenter = {
  pageTitle: "Notification center",
  loading: "Loading notifications",
  tabs: {
    reporting: "Reporting",
    reportingCalendar: "Reporting calendar",
    messages: "Messages",
    registrationTracker: "Registration tracker",
    thresholds: "Thresholds",
    cases: "Cases",
    chargeInvoices: "Charge invoices",
    fundRequests: "Request of Funds",
    product: "Product",
    invoices: "Invoices",
    transactions: "Transactions",
    consumption: "Consumption",
    billing: "Billing",
    settings: "Settings",
    registrations: "Registrations",
    deadlines: "Deadlines",
  },
  sections: {
    reporting: {
      main: "Reporting",
    },
    reportingCalendar: {
      main: "Reporting calendar",
    },
    messages: {
      main: "Messages",
    },
    registrationTracker: {
      main: "Registration tracker",
    },
    thresholds: {
      main: "Thresholds",
    },
    cases: {
      main: "Cases",
    },
    chargeInvoices: {
      main: "Charge invoices",
    },
    fundRequests: {
      main: "Request of Funds",
    },
    product: {
      main: "Product",
    },
    invoices: {
      main: "Invoices",
    },
    transactions: {
      main: "Transactions",
    },
    consumption: {
      main: "Consumption",
    },
    billing: {
      main: "Billing",
    },
    settings: {
      main: "Settings",
    },
    registrations: {
      main: "Registrations",
    },
    deadlines: {
      main: "Deadlines",
    },
  },
  columns: {
    company: "Company",
    created: "Created",
    number: "Number",
    requested: "Requested",
    received: "Received",
    balance: "Balance",
    period: "Period",
    countryJurisdiction: "Country/Jurisdiction",
    typeOfReport: "Type of report",
    dueDate: "Due date",
    type: "Type",
    subject: "Subject",
    status: "Status",
    documents: "Documents",
    dateLastStatusChanged: "Date last status\nchanged",
    generatedBy: "Generated by",
    app: "App",
    typeOfSubscription: "Type of subscription",
    typeOfLimit: "Type of limit",
    limit: "Limit",
    source: "Source",
    description: "Description",
    amount: "Amount",
    payer: "Payer",
    typeOfNumber: "Type of number",
    typeOfInvoice: "Type of invoice",
    counterparty: "Counterparty",
    jurisdiction: "Jurisdiction",
    date: "Date",
    companiesList: "Companies list",
    orderDate: "Order date",
    category: "Category",
    estimatedRegistrationDate: "Estimated date of\nregistration",
    lastUpdated: "Last updated",
    filingDate: "Filing date",
    comments: "Comments",
    comment: "Comment",
    registrator: "Registrator",
    typeOfRegistration: "Type of registration",
    subcategoryOfRegistration: "Subcategory of\nregistration",
    estimateDateOfRegistration: "Estimate date of\nregistration",
    percentReached: "% reached",
    dateWhen100Reached: "Date when 100%\nreached",
    actions: "Actions",
  },
  actions: {
    openRequest: "Open request",
    openInNewTab: "Open in new tab",
    openBillingHistory: "Open in Billing history",
    seen: "Seen",
    viewDocumentRequestDetails: "View details",
    addComment: "Add comment",
    changeStatus: "Change status",
    delete: "Delete",
    markRequiresAttention: "Mark as requires attention",
    removeAttentionFlag: "Remove attention flag",
  },
  changeStatusModal: {
    title: "Change status",
    status: "Status",
    placeholder: "Select status",
    cancel: "Cancel",
    confirm: "Save",
  },
  documentRequestDrawer: {
    title: "Document request details",
    subject: "Subject",
    requestedOn: "Requested on",
    requestedBy: "Requested by",
    uploadedDocuments: "Uploaded documents ({{count}})",
    noDocuments: "No documents uploaded yet",
    openDocument: "Open document",
  },
  documents: {
    uploadedCount: "{{count}} uploaded",
    underReview: "Under review",
    awaitingDocuments: "Awaiting documents",
  },
  filters: {
    visibility: {
      mine: "Show mine",
      all: "Show all",
    },
    deadlinesPrefix: "Deadlines:",
    deadlines: {
      next3Days: "Next 3 days",
      forthcoming: "Forthcoming",
      all: "All",
      missed: "Missed",
    },
    declarationTypePrefix: "Type of report:",
    declarationType: {
      all: "All",
      declaration: "VAT declarations",
      salesTaxReturn: "Sales Tax",
      eprReport: "EPR",
    },
    registrations: {
      company: "Company",
      companyPrefix: "Company:",
      allCompanies: "All companies",
      orderDate: "Order date",
      orderDatePrefix: "Order date:",
      jurisdiction: "Country / Jurisdiction",
      jurisdictionPrefix: "Jurisdiction:",
      allJurisdictions: "All jurisdictions",
      typeOfRegistration: "Type of registration",
      typeOfRegistrationPrefix: "Type of registration:",
      allTypesOfRegistration: "All types",
      subcategory: "Subcategory of registration",
      subcategoryPrefix: "Subcategory:",
      allSubcategories: "All subcategories",
      status: "Status",
      statusPrefix: "Status:",
      allStatuses: "All statuses",
      dateLastStatusChanged: "Date last status changed",
      dateLastStatusChangedPrefix: "Date last status changed:",
      registrator: "Registrator",
      registratorPrefix: "Registrator:",
      allRegistrators: "All registrators",
      estimatedRegistrationDate: "Estimate date of registration",
      estimatedRegistrationDatePrefix: "Estimate date of registration:",
      newestFirst: "Newest first",
      oldestFirst: "Oldest first",
      clearSort: "Clear",
      sort: "Sort",
    },
  },
  empty: {
    title: "No notifications",
    description: "There are no items in this section.",
    tabPlaceholder: "This section will be available soon.",
    noTablesForRole: "No notification sections are available for your account.",
  },
};

export default notificationCenter;
